import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import EmpleadosService from "../services/EmpleadosService";
import SucursalesService from "../services/SucursalesService";
import DepartamentosService from "../services/DepartamentosService";

import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  IconButton,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import Swal from "sweetalert2";
import { mostrarToast } from "../utils/toastUtils";
import { tieneMasDe10Digitos } from "../utils/telefonoUtils";

const Empleados = () => {
  useEffect(() => {
    document.title = "Empleados";
  }, []);

  function mostrarMensaje(mensaje) {
    mostrarToast(mensaje, "success");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }



  async function mostrarBuscarEmpleado() {
    let empleadosOriginal = [];
    let empleadosActivos = [];

    const ordenarEmpleadosRecientes = (lista) => {
      if (!Array.isArray(lista)) return [];
      return [...lista].sort(
        (a, b) => Number(b.idEmpleado || b.id || 0) - Number(a.idEmpleado || a.id || 0),
      );
    };

    const resultado = await EmpleadosService.getEmpleados();
    empleadosOriginal = ordenarEmpleadosRecientes(resultado?.data?.empleados || resultado?.empleados || []);
    empleadosActivos = [...empleadosOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (lista) => {
      return lista
        .map(
          (emp, idx) => `
              <tr style="background-color: ${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom: 1px solid #e2e8f0; font-size: 0.80rem; transition: background 0.15s;">
                <td style="padding: 6px 12px; text-align: left; font-weight: 500; color: #1e293b; border-right: 1px solid #f1f5f9;">${emp.nombre} ${emp.apPaterno} ${emp.apMaterno}</td>
                <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
                  <button data-action="mostrar" data-id-empleado="${emp.idEmpleado}" title="Mostrar" style="background: #e0f2fe; color: #0284c7; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
                    <i class="fas fa-eye"></i>
                  </button>
                </td>
                <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
                  <button data-action="editar" data-id-empleado="${emp.idEmpleado}" title="Editar" style="background: #fef3c7; color: #d97706; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
                    <i class="fas fa-edit"></i>
                  </button>
                </td>
                <td style="padding: 4px 6px; text-align: center;">
                  <button data-action="eliminar" data-id-empleado="${emp.idEmpleado}" title="Eliminar" style="background: #fee2e2; color: #dc2626; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            `,
        )
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginaEmpleados = empleadosActivos.slice(inicio, fin);
      const tabla = document.getElementById("tablaEmpleados");
      if (tabla) {
        if (!paginaEmpleados || paginaEmpleados.length === 0) {
          tabla.innerHTML = `<tr><td colspan="4" style="padding: 24px; text-align: center; color: #64748b; font-style: italic;">No hay registros</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginaEmpleados);
        }
        tabla
          .querySelectorAll("button[data-action='mostrar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idEmpleado;
              const empleado = empleadosOriginal.find(
                (item) => String(item.idEmpleado) === String(id),
              );
              if (empleado) {
                verEmpleado(empleado);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='editar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idEmpleado;
              const empleado = empleadosOriginal.find(
                (item) => String(item.idEmpleado) === String(id),
              );
              if (empleado) {
                editarEmpleado(empleado);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='eliminar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idEmpleado;
              const empleado = empleadosOriginal.find(
                (item) => String(item.idEmpleado) === String(id),
              );
              if (empleado) {
                Swal.fire({
                  title: "¿Eliminar empleado?",
                  text: `¿Desea eliminar al empleado ${empleado.nombre} ${empleado.apPaterno}?`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Sí, eliminar",
                  cancelButtonText: "Cancelar",
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    await eliminarEmpleado(empleado.idEmpleado);
                  }
                });
              }
            });
          });
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(empleadosActivos.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${empleadosActivos.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.45" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.45" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "BUSCAR EMPLEADO",
      width: "60%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
              <div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; text-align: left;">
                <div style="display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; margin-bottom: 8px;">
                  <div style="display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 220px;">
                    <label style="font-size: 0.80rem; font-weight: 600; color: #334155;">Nombre del empleado:</label>
                    <input id="buscarEmpleado" type="text" style="padding: 5px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.82rem; outline: none; height: 32px; box-sizing: border-box;" placeholder="Escribe aquí...">
                  </div>
                  <div>
                    <button id="btnMostrarTodos" style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; border: none; border-radius: 6px; font-weight: 600; font-size: 0.80rem; padding: 6px 14px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1); height: 32px; white-space: nowrap; transition: opacity 0.2s;">
                      Mostrar todos los empleados
                    </button>
                  </div>
                </div>

                <div style="width: 100%; overflow: auto; max-height: 52vh; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.08); background: white;">
                  <table class="tablaEmpleados" style="width: 100%; border-collapse: collapse; text-align: center;">
                    <thead>
                      <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.80rem; position: sticky; top: 0; z-index: 2;">
                        <th style="padding: 7px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Nombre del empleado</th>
                        <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Mostrar</th>
                        <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Editar</th>
                        <th style="padding: 7px 8px; text-align: center; font-weight: 600; width: 45px;">Eliminar</th>
                      </tr>
                    </thead>
                    <tbody id="tablaEmpleados">
                    </tbody>
                  </table>
                </div>

                <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center;">
                  <span id="paginaActual" style="font-size: 0.80rem; color: #64748b; font-weight: 500;"></span>
                  <div style="display: flex; gap: 6px;">
                    <button id="btnAnterior" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Anterior</button>
                    <button id="btnSiguiente" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Siguiente</button>
                  </div>
                </div>
              </div>
            `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });


        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (paginaActual < Math.ceil(empleadosActivos.length / porPagina)) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnMostrarTodos")
          .addEventListener("click", async () => {
            try {
              const resultado = await EmpleadosService.getEmpleados();
              empleadosOriginal = ordenarEmpleadosRecientes(resultado?.data?.empleados || resultado?.empleados || []);
              empleadosActivos = [...empleadosOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error al recargar empleados:", error);
            }
            document.getElementById("buscarEmpleado").value = "";
          });
        document
          .getElementById("buscarEmpleado")
          .addEventListener("input", async (e) => {
            const valor = e.target.value.trim();
            paginaActual = 1;
            if (valor === "") {
              empleadosActivos = [...empleadosOriginal];
              renderPagina(paginaActual);
              return;
            }

            try {

              const resultado = await EmpleadosService.buscarEmpleados(valor);
              empleadosActivos = ordenarEmpleadosRecientes(resultado?.empleados || resultado?.data?.empleados || []);
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error en búsqueda:", error);
            }
          });
      },
    });
  }

  const verEmpleado = (empleado) => {

    setTitulo(empleado.titulo || "");
    setCedula(empleado.cedula || "");
    setTurno(empleado.turno || "");

    setNombre(empleado.nombre || "");
    setApPaterno(empleado.apPaterno || "");
    setApMaterno(empleado.apMaterno || "");
    setSexo(empleado.sexo || "");
    setCalle(empleado.calle || "");
    setColonia(empleado.colonia || "");
    setCPostal(empleado.cPostal || "");
    setCiudad(empleado.ciudad || "");
    setFechaNac(empleado.fechaNacimiento || "");
    setTelefonoTrabajo(empleado.telefonoTrabajo || "");
    setTelefonoCel(empleado.telefonoCelular || "");
    setEmail(empleado.email || "");
    setUsuario(empleado.usuario || "");
    setContrasenia(empleado.contrasenia || "");
    setNombreSucursal(empleado.nombreSucursal || "");
    setNombreDepartamento(empleado.nombreDepartamento || "");
    setSelectedEmpleadoId(null);
    setSucursalId(empleado.idSucursal || "");
    setDepartamentoId(empleado.idDepartamento || "");
    setEditMode(false);
    setViewOnly(true);
  };

  const editarEmpleado = (empleado) => {
    setTitulo(empleado.titulo || "");
    setCedula(empleado.cedula || "");
    setTurno(empleado.turno || "");

    setNombre(empleado.nombre || "");
    setApPaterno(empleado.apPaterno || "");
    setApMaterno(empleado.apMaterno || "");
    setSexo(empleado.sexo || "");
    setCalle(empleado.calle || "");
    setColonia(empleado.colonia || "");
    setCPostal(empleado.cPostal || "");
    setCiudad(empleado.ciudad || "");
    setFechaNac(empleado.fechaNacimiento || "");
    setTelefonoTrabajo(empleado.telefonoTrabajo || "");
    setTelefonoCel(empleado.telefonoCelular || "");
    setEmail(empleado.email || "");
    setUsuario(empleado.usuario || "");
    setContrasenia(empleado.contrasenia || "");
    setNombreSucursal(empleado.nombreSucursal || "");
    setNombreDepartamento(empleado.nombreDepartamento || "");
    setSelectedEmpleadoId(empleado.idEmpleado);
    setSucursalId(empleado.idSucursal);
    setDepartamentoId(empleado.idDepartamento);
    setEditMode(true);
    setViewOnly(false);
  };

  function reloadPage() {
    window.location.reload();
  }

  const [titulo, setTitulo] = useState("");
  const [cedula, setCedula] = useState("");
  const [turno, setTurno] = useState("");
  const [nombre, setNombre] = useState("");
  const [apPaterno, setApPaterno] = useState("");
  const [apMaterno, setApMaterno] = useState("");
  const [sexo, setSexo] = useState("");
  const [calle, setCalle] = useState("");
  const [colonia, setColonia] = useState("");
  const [cPostal, setCPostal] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [fechaNac, setFechaNac] = useState("");
  const [telefonoTrabajo, setTelefonoTrabajo] = useState("");
  const [telefonoCel, setTelefonoCel] = useState("");
  const [email, setEmail] = useState("");
  const [usuario, setUsuario] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [confirmContrasenia, setConfirmContrasenia] = useState("");
  const [nombreSucursal, setNombreSucursal] = useState("");
  const [nombreDepartamento, setNombreDepartamento] = useState("");
  const [errorNombre, setErrorNombre] = useState(false);
  const [errorApPaterno, setErrorApPaterno] = useState(false);
  const [errorSucursal, setErrorSucursal] = useState(false);
  const [errorDepartamento, setErrorDepartamento] = useState(false);
  const [errorTurno, setErrorTurno] = useState(false);
  const [errorCiudad, setErrorCiudad] = useState(false);
  const [errorCalle, setErrorCalle] = useState(false);
  const [errorColonia, setErrorColonia] = useState(false);
  const [errorCPostal, setErrorCPostal] = useState(false);
  const [errorSexo, setErrorSexo] = useState(false);
  const [selectedEmpleadoId, setSelectedEmpleadoId] = useState(null);
  const [sucursalId, setSucursalId] = useState(null);
  const [departamentoId, setDepartamentoId] = useState(null);
  const [viewOnly, setViewOnly] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = usuarioString ? JSON.parse(usuarioString) : null;
  const isUserAdmin = currentU?.rol === "A";
  const mostrarCamposUsuario = !editMode || isUserAdmin;

  const [sucursales, setSucursales] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [cargandoSucursales, setCargandoSucursales] = useState(true);


  useEffect(() => {
    const cargarSucursales = async () => {
      try {
        const resultado = await SucursalesService.getSucursales();
        setSucursales(resultado.data.sucursales);
      } catch (error) {
        console.error("Error al cargar sucursales:", error);
        setSucursales([]);
      } finally {
        setCargandoSucursales(false);
      }
    };
    cargarSucursales();
  }, []);


  useEffect(() => {
    if (sucursalId && sucursalId !== "seleccione") {
      const cargarDepartamentos = async () => {
        try {
          const resultado = await DepartamentosService.getDepartamentosPorSucursal(sucursalId);
          setDepartamentos(resultado.departamentos || []);
        } catch (error) {
          console.error("Error al cargar departamentos:", error);
          setDepartamentos([]);
        }
      };
      cargarDepartamentos();
    } else {
      setDepartamentos([]);
    }
  }, [sucursalId]);

  const registrarEmp = async () => {
    if (nombre === "" && apPaterno === "" && sucursalId === null && departamentoId === null && turno === "" && ciudad === "" && calle === "" && colonia === "" && cPostal === "" && sexo === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombre(true);
      setErrorApPaterno(true);
      setErrorSucursal(true);
      setErrorDepartamento(true);
      setErrorTurno(true);
      setErrorCiudad(true);
      setErrorCalle(true);
      setErrorColonia(true);
      setErrorCPostal(true);
      setErrorSexo(true);
    } else if (nombre === "") {
      mostrarError("Rellene los campos obligatorios!");
      setErrorNombre(true);
    } else if (apPaterno === "") {
      mostrarError("Rellene los campos obligatorios!");
      setErrorApPaterno(true);
    } else if (sucursalId === null) {
      mostrarError("Rellene los campos obligatorios!");
      setErrorSucursal(true);
    } else if (departamentoId === null) {
      mostrarError("Rellene los campos obligatorios!");
      setErrorDepartamento(true);
    } else if (turno === "") {
      mostrarError("Rellene los campos obligatorios!");
      setErrorTurno(true);
    } else if (ciudad === "") {
      mostrarError("Rellene los campos obligatorios!");
      setErrorCiudad(true);
    } else if (calle === "") {
      mostrarError("Rellene los campos obligatorios!");
      setErrorCalle(true);
    } else if (colonia === null) {
      mostrarError("Rellene los campos obligatorios!");
      setErrorColonia(true);
    } else if (cPostal === null) {
      mostrarError("Rellene los campos obligatorios!");
      setErrorCPostal(true);
    } else if (sexo === "") {
      mostrarError("Rellene los campos obligatorios!");
      setErrorSexo(true);
    } else if (tieneMasDe10Digitos(telefonoTrabajo)) {
      mostrarError("El teléfono (casa) no puede tener más de 10 dígitos.");
    } else if (tieneMasDe10Digitos(telefonoCel)) {
      mostrarError("El teléfono (celular) no puede tener más de 10 dígitos.");
    }
    else {
      if (mostrarCamposUsuario && contrasenia !== confirmContrasenia) {
        mostrarError("Las contraseñas no coinciden!");
        return;
      }

      let empleado = {
        titulo: titulo,
        cedula: cedula,
        turno: turno,
        nombre: nombre,
        apPaterno: apPaterno,
        apMaterno: apMaterno,
        sexo: sexo,
        calle: calle,
        colonia: colonia,
        ciudad: ciudad,
        cPostal: cPostal,
        fechaNacimiento: fechaNac,
        telefonoTrabajo: telefonoTrabajo,
        telefonoCelular: telefonoCel,
        email: email,
        usuarioN: usuario,
        contrasenia: contrasenia,
        idSucursal: sucursalId,
        idDepartamento: departamentoId,
      };

      let empleadoUpd = {
        tituloN: titulo,
        cedulaN: cedula,
        turnoN: turno,
        nombreN: nombre,
        apPaternoN: apPaterno,
        apMaternoN: apMaterno,
        sexoN: sexo,
        calleN: calle,
        coloniaN: colonia,
        ciudadN: ciudad,
        cPostalN: cPostal,
        fechaNacimientoN: fechaNac,
        telefonoTrabajoN: telefonoTrabajo,
        telefonoCelularN: telefonoCel,
        emailN: email,
        usuarioN: mostrarCamposUsuario ? usuario : (usuario || ""),
        contraseniaN: mostrarCamposUsuario ? contrasenia : "",
        idSucursalN: sucursalId,
        idDepartamentoN: departamentoId,
      };

      try {
        let resultado;
        if (editMode && selectedEmpleadoId) {
          resultado = await EmpleadosService.updateEmpleado(
            empleadoUpd,
            selectedEmpleadoId,
          );
        } else {
          resultado = await EmpleadosService.agregarEmpleado(empleado);
        }
        if (resultado.data.estatus === "OK") {
          mostrarMensaje(
            editMode
              ? "Empleado actualizado con éxito!"
              : "Empleado agregado con exito!",
          );
        } else {
          mostrarError(
            editMode
              ? "No se pudo actualizar el empleado: " + resultado.data.mensaje
              : "No se pudo agregar el empleado: " + resultado.data.mensaje,
          );
        }
      } catch (error) {
        mostrarError(
          editMode
            ? "Error al actualizar empleado:"
            : "Error al agregar empleado:" + error,
          error,
        );
      }
    }
  };
  const eliminarEmpleado = async (empleadoId) => {
    try {
      const resultado = await EmpleadosService.deleteEmpleado(empleadoId);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Empleado eliminado con éxito!");
      } else {
        mostrarError("Error al eliminar empleado");
      }
    } catch (error) {
      console.error("Error al eliminar empleado:", error);
      mostrarError("Error al eliminar empleado");
    }
  };

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Stack spacing={2} sx={{ width: "95vw", maxWidth: "96vw" }}>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperEmp"
            >
              <Typography
                variant="h7"
                fontWeight="bold"
                gutterBottom
                sx={{
                  background: "linear-gradient(90deg, #006787, #014e65)",
                  color: "white",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  display: "inline-block",
                  fontWeight: "bold",
                }}
              >
                DATOS DEL EMPLEADO
              </Typography>

              {/* Contenedor principal */}
              <Grid container spacing={"0.3vw"}>
                {/* Nombre y apellidos */}
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{ paddingTop: "0vw" }}
                >
                  <Stack direction="row" spacing={"3vw"}>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfNombre"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Nombre: <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={nombre}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setNombre(e.target.value);
                          if (errorNombre && e.target.value.trim() !== "") {
                            setErrorNombre(false);
                          }
                        }}
                        error={errorNombre}
                        helperText={errorNombre ? "Nombre obligatorio" : ""}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfNombre"
                        required
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfApPaterno"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Apellido Paterno:{" "}
                        <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={apPaterno}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setApPaterno(e.target.value);
                          if (errorApPaterno && e.target.value.trim() !== "") {
                            setErrorApPaterno(false);
                          }
                        }}
                        error={errorApPaterno}
                        helperText={
                          errorApPaterno ? "Apellido paterno obligatorio" : ""
                        }
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfApPaterno"
                        required
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <InputLabel
                        htmlFor="txfApMaterno"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Apellido Materno:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={apMaterno}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setApMaterno(e.target.value);
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfApMaterno"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <FormControl>
                        <FormLabel
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Sexo:
                          <span style={{ color: "red" }}>*</span>
                        </FormLabel>
                        <RadioGroup row
                          value={sexo}
                          disabled={viewOnly}
                          onChange={(e) => {
                            setSexo(e.target.value);
                            if (errorSexo && e.target.value.trim() !== "") {
                              setErrorSexo(false);
                            }
                          }}
                          error={errorSexo}
                          helperText={errorSexo ? "Obligatorio" : ""}>
                          <FormControlLabel
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontSize: "1vw",
                                fontWeight: "bold",
                              },
                            }}
                            value="M"
                            control={
                              <Radio
                                disabled={viewOnly}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    height: "1vw",
                                    width: "1vw",
                                  },
                                }}
                              />
                            }
                            label="Masculino"
                          />
                          <FormControlLabel
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontSize: "1vw",
                                fontWeight: "bold",
                              },
                            }}
                            value="F"
                            control={
                              <Radio
                                disabled={viewOnly}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    height: "1vw",
                                    width: "1vw",
                                  },
                                }}
                              />
                            }
                            label="Femenino"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    {/* Fecha de nacimiento */}
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfFechaNacimiento"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Fecha de Nacimiento:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={fechaNac}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setFechaNac(e.target.value);
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            width: "13vw",
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfFechaNacimiento"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                  </Stack>
                  {/* Sexo y estado civil */}

                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0.4vw" }}
                  >
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfCalle"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Calle:
                          <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={calle}
                          disabled={viewOnly}
                          onChange={(e) => {
                            setCalle(e.target.value);
                            if (errorCalle && e.target.value.trim() !== "") {
                              setErrorCalle(false);
                            }
                          }}
                          error={errorCalle}
                          helperText={errorCalle ? "Calle obligatorio" : ""}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfCalle"
                        />
                      </Grid>
                      {/* Email y teléfonos */}
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfColonia"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Colonia:
                          <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={colonia}
                          disabled={viewOnly}
                          onChange={(e) => {
                            setColonia(e.target.value);
                            if (errorColonia && e.target.value.trim() !== "") {
                              setErrorColonia(false);
                            }
                          }}
                          error={errorColonia}
                          helperText={errorColonia ? "Colonia obligatorio" : ""}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfColonia"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfCPostal"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Código Postal:
                          <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={cPostal}
                          disabled={viewOnly}
                          onChange={(e) => {
                            setCPostal(e.target.value);
                            if (errorCPostal && e.target.value.trim() !== "") {
                              setErrorCPostal(false);
                            }
                          }}
                          error={errorCPostal}
                          helperText={errorCPostal ? "CPostal obligatorio" : ""}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfCPostal"
                        />
                      </Grid>

                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfCiudad"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Ciudad:
                          <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={ciudad}
                          disabled={viewOnly}
                          onChange={(e) => {
                            setCiudad(e.target.value);
                            if (errorCiudad && e.target.value.trim() !== "") {
                              setErrorCiudad(false);
                            }
                          }}
                          error={errorCiudad}
                          helperText={errorCiudad ? "Ciudad obligatorio" : ""}

                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfCiudad"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfTelefonoTrabajo"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                            ml: "1.8vw"
                          }}
                        >
                          Telefono(Casa):
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={telefonoTrabajo}
                          disabled={viewOnly}
                          error={tieneMasDe10Digitos(telefonoTrabajo)}
                          helperText={tieneMasDe10Digitos(telefonoTrabajo) ? "Máximo 10 dígitos" : ""}
                          onChange={(e) => {
                            setTelefonoTrabajo(e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw",
                              ml: "1.8vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfTelefonoTrabajo"
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0.4vw" }}
                  >
                    <Stack direction="row" spacing={"3vw"}>

                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfTelefonoCel"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Telefono(Celular):
                        </InputLabel>
                        <TextField
                          fullWidth
                          value={telefonoCel}
                          disabled={viewOnly}
                          error={tieneMasDe10Digitos(telefonoCel)}
                          helperText={tieneMasDe10Digitos(telefonoCel) ? "Máximo 10 dígitos" : ""}
                          onChange={(e) => {
                            setTelefonoCel(e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "13vw"
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfTelefonoCel"
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
            {/* Lugar de atencion */}
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperEmpInf"
            >
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0vw" }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      marginTop: "0vw",
                      fontWeight: "bold",
                    }}
                  >
                    INFORMACION LABORAL
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="txfTitulo"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Titulo Profesional:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={titulo}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setTitulo(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfTitulo"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel
                      htmlFor="txfCedula"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Cédula Profesional:
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={cedula}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setCedula(e.target.value);
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "5vh",
                          width: "13vw"
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1vw",
                          padding: "0.5vw",
                        },
                      }}
                      className="txfCedula"
                    />
                  </Grid>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "1vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="selectSucursal"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Sucursal:<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      input={<OutlinedInput />}
                      value={sucursalId}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setSucursalId(e.target.value);
                      }}
                      sx={{
                        flex: "0 0 8vw",
                        width: "13vw",
                        maxWidth: "100%",

                        height: "5vh",
                        minHeight: "0px !important",
                        overflow: "hidden",


                        "&.MuiInputBase-root": {
                          minHeight: "0px !important",
                        },

                        "& .MuiSelect-select": {
                          minHeight: "0px !important",
                          padding: "0 0.5vw !important",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "1vw",
                          lineHeight: "1",
                        },

                        "& .MuiOutlinedInput-notchedOutline": {

                          top: 0,
                          "& legend": { display: "none" },
                        },

                        "& .MuiSvgIcon-root": {
                          display: "inline-block !important",
                          position: "absolute",
                          right: "0.5vw",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "1.2vw !important",
                          width: "1.2vw !important",
                          height: "1.2vw !important",
                          pointerEvents: "none",

                        },
                        minWidth: "0px !important",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      className="selectSucursal"
                    >
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value=""
                        disabled
                      >
                        Seleccione
                      </MenuItem>
                      {sucursales.map((sucursal) => (
                        <MenuItem
                          key={sucursal.idSucursal}
                          value={sucursal.idSucursal}
                          sx={{
                            fontSize: "1vw",
                            padding: "0.5vw",
                          }}
                        >
                          {sucursal.nombre || sucursal.nombreSucursal}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="selectDepartamento"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Departamento:<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      input={<OutlinedInput />}
                      value={departamentoId}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setDepartamentoId(e.target.value);
                      }}
                      sx={{
                        flex: "0 0 8vw",
                        width: "13vw",
                        height: "5vh",
                        maxWidth: "100%",

                        minHeight: "0px !important",
                        overflow: "hidden",


                        "&.MuiInputBase-root": {
                          minHeight: "0px !important",
                        },

                        "& .MuiSelect-select": {
                          minHeight: "0px !important",
                          padding: "0 0.5vw !important",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "1vw",
                          lineHeight: "1",
                        },

                        "& .MuiOutlinedInput-notchedOutline": {

                          top: 0,
                          "& legend": { display: "none" },
                        },

                        "& .MuiSvgIcon-root": {
                          display: "inline-block !important",
                          position: "absolute",
                          right: "0.5vw",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "1.2vw !important",
                          width: "1.2vw !important",
                          height: "1.2vw !important",
                          pointerEvents: "none",

                        },
                        minWidth: "0px !important",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      className="selectDepartamento"
                    >
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value=""
                        disabled
                      >
                        Seleccione
                      </MenuItem>
                      {departamentos.map((departamento) => (
                        <MenuItem
                          key={departamento.idDepartamento}
                          value={departamento.idDepartamento}
                          sx={{
                            fontSize: "1vw",
                            padding: "0.5vw",
                          }}
                        >
                          {departamento.nombre || departamento.nombreDepartamento}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel
                      htmlFor="selectTurno"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Turno:<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      input={<OutlinedInput />}
                      value={turno}
                      disabled={viewOnly}
                      onChange={(e) => {
                        setTurno(e.target.value);
                      }}
                      sx={{
                        flex: "0 0 8vw",
                        width: "13vw",
                        maxWidth: "100%",

                        height: "5vh",
                        minHeight: "0px !important",
                        overflow: "hidden",


                        "&.MuiInputBase-root": {
                          minHeight: "0px !important",
                        },

                        "& .MuiSelect-select": {
                          minHeight: "0px !important",
                          padding: "0 0.5vw !important",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "1vw",
                          lineHeight: "1",
                        },

                        "& .MuiOutlinedInput-notchedOutline": {

                          top: 0,
                          "& legend": { display: "none" },
                        },

                        "& .MuiSvgIcon-root": {
                          display: "inline-block !important",
                          position: "absolute",
                          right: "0.5vw",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "1.2vw !important",
                          width: "1.2vw !important",
                          height: "1.2vw !important",
                          pointerEvents: "none",

                        },
                        minWidth: "0px !important",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      className="selectTurno"
                    >
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value="seleccione"
                        disabled
                      >
                        Seleccione
                      </MenuItem>
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value="Matutino"

                      >
                        Matutino
                      </MenuItem>
                      <MenuItem
                        sx={{
                          fontSize: "1vw",
                          padding: "0.5vw",
                        }}
                        value="Vespertino"

                      >
                        Vespertino
                      </MenuItem>
                    </Select>
                  </Grid>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "1vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>

                </Stack>
              </Grid>
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperEmpUser"
            >
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0vw" }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      marginTop: "vw",
                      fontWeight: "bold"
                    }}
                  >
                    CUENTA DE USUARIO
                  </Typography>
                </Box>
              </Grid>
              {mostrarCamposUsuario && (
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"10vw"}
                  sx={{ paddingTop: "0.4vw" }}
                >
                  <Stack direction="row" spacing={"16vw"}>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="txfUsuario"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold"
                        }}
                      >
                        Usuario:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={usuario}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setUsuario(e.target.value);
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfUsuario"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="txfContrasena"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold"
                        }}
                      >
                        Contraseña:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={contrasenia}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setContrasenia(e.target.value);
                        }}
                        type="password"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfContrasena"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="txfConfContrasena"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold"
                        }}
                      >
                        Confirmar Contraseña:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={confirmContrasenia}
                        disabled={viewOnly}
                        onChange={(e) => {
                          setConfirmContrasenia(e.target.value);
                        }}
                        type="password"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                            width: "13vw"
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfConfContrasena"
                      />
                    </Grid>
                  </Stack>
                </Grid>
              )}
            </Paper>
          </Stack>
        </Box>
        <Box
          sx={{
            position: "fixed",
            right: "6vw",
            top: "30%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {!viewOnly && (
            <Tooltip
              title={"Guardar empleado"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    fontFamily: "Roboto-Medium",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
                onClick={registrarEmp}
              >
                <SaveIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip
            title={"Nuevo empleado"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={reloadPage}
            >
              <AddIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>

          <Tooltip
            title={"Buscar empleado"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={mostrarBuscarEmpleado}
            >
              <SearchIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Content>
    </Layout>
  );
};
export default Empleados;
